import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activePointsTab: 0,
  activeTab: 0,
};

const transactionSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    setActivePointTab: (state, action) => ({
      ...state,
      activePointsTab: action.payload,
    }),
    setActiveTab: (state, action) => ({
      ...state,
      activeTab: action.payload,
    }),
  },
});

export const { setActivePointTab, setActiveTab } = transactionSlice.actions;
export default transactionSlice;
